import { useDispatch, useSelector } from "react-redux";
import { act, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { AppDispatch, RootState } from "store";
import { fetchLiveSessionActivityData, resetLiveStreamSettings, unraiseQuery, updateLiveStreamSettings, updateSessionSettings } from "store/reducers/livestreamSettings";
import { addResponse } from "store/reducers/countReducer";
import LogoutControl from "./components/controls/Logout";
import { LeftPanel, ModeHeading, PlayArea } from "./components";
import TraineeDraggableCard from "./components/TraineeDraggableCard";
import ConsoleControlPanel from "./components/controls";
import { SessionPlanPanel } from "./components/panels";
import useSocket from "./websocket/useSocket";
import Icon from "assets/icons";
import { GoArrowSwitch, GoArrowUp, GoArrowDown } from "react-icons/go";
import { HiSwitchHorizontal } from "react-icons/hi";
import "../../styles/notch.css";
import RoomClient from "components/containers/utils/mediaSoup/RoomClient";
import { useMediaStream } from "hooks";
import store from "store";
import { Consumer } from "mediasoup-client/lib/types";
import ScreenSharingComponent from "./components/backup/ShareScreen";
import { validateAndCreateSocketIfExist } from "utils/SocketValidator";
import { socketContextType } from "index";
import SocketContext from "socket-context";
import { UserInfoMapperSocketHandler } from "utils/UserInfoMapper";
import {
  csSubtype,
  screenTypes,
  sessionModeType,
  sessionPlanActivityType,
  socketMessageType,
} from "types/Constants";
import { de } from "date-fns/locale";
import { InstructorModeMainScreen } from "./components/backup/instructorModeScreens";
import ClusterTableSittingAlignment from "./components/tables/ClusterTableSittingAlignment";
import PollActivity from "components/session-activity/PollActivity";
import { User } from "models/User";
import { FaChevronUp, FaChevronDown, FaHandPaper, FaTimes, FaExternalLinkAlt, FaRedo } from "react-icons/fa";
import { addCommonCount, addPrivateCount, setMicState, updateSidePanelData } from "store/reducers/countReducer";
import GroupDiscussion from "components/session-activity/Group_Discussion/GroupDiscussion";
import ActivityService from "services/Activity";
import CaseStudyScreen from "components/session-activity/Case_Study/CaseStudyScreen";
import RolePlay from "components/session-activity/Role_Play";
import MyDocumentViewer from "./components/backup/MyDocumentViewer";
import VideoScreen from "./components/backup/VideoScreen";
import UrlParse from 'url-parse';
import useMediaQuery from "hooks/useMediaQuery";
import Trainer from "./components/backup/Trainer";
import LiveSessionService from "services/LiveSessionService";
import ChangeBackGround from "./components/changebackground";
import EmojiePopup from "./components/panels/emojie-popup";
import axiosInstance from "config/axios";
import QueryPopup from "components/panels/QueryPopup";
import DocViewer, { DocRenderer, DocViewerRenderers } from 'react-doc-viewer';
import ReactPlayer from 'react-player';
import { Dialog, Text, Button } from "@radix-ui/themes";

interface SidePanelState {
  participantPanelOpen: boolean;
  participantPanelWidth: number;
  sessionPlanPanelOpen: boolean;
  sessionPanelWidth: number;
}

let activityService = new ActivityService();

const AudioPlayer = ({ consumer }: { consumer: any }) => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const onSpeaker = useSelector((state: RootState) => state.live.settings.onSpeaker);

  useEffect(() => {
    if (consumer.track && audioRef.current) {
      const mediaStream = new MediaStream();
      mediaStream.addTrack(consumer.track);
      audioRef.current.srcObject = mediaStream;

      // Try to play when onSpeaker is true
      if (onSpeaker) {
        audioRef.current
          .play()
          .then(() => console.log("Audio play success"))
          .catch((err) => {
            if (err.name !== "AbortError") {
              console.error("Audio play error:", err);
            }
          });
      } else {
        // Mute and pause when onSpeaker is false
        audioRef.current.pause();
        audioRef.current.muted = true;
      }
    }
  }, [consumer.track, onSpeaker]);

  // Sync mute state if onSpeaker changes
  useEffect(() => {
    if (!audioRef.current) return;
    if (onSpeaker) {
      audioRef.current.muted = false;
      audioRef.current.play().catch((err) => {
        if (err.name !== "AbortError") console.error("Resume play error:", err);
      });
    } else {
      audioRef.current.muted = true;
      audioRef.current.pause();
    }
  }, [onSpeaker]);

  if (!consumer.track) return null;

  return <audio ref={audioRef} autoPlay playsInline />;
};


const ClassRoom = () => {
  const roomClientRef = useRef<RoomClient | null>(null);
  const { trainer, onlineParticipants, batch, userStream, activeQueries, bgImage, pendingBg } = useSelector(
    (state: RootState) => state.live.settings
  );
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("sessionId");
  let programId = searchParams.get("programId");
  const isMobileOrTablet = useMediaQuery("(max-width: 1024px)");
  const urlParser = new UrlParse(window.location.href, true);
  const settings: any = useSelector((state: RootState) => state.live.settings);
  const { consoleDetails } = useSelector((state: RootState) => state.live.settings);
  const [showPanel, setShowPanel] = useState(true);
  const [shouldRenderRightPanel, setShouldRenderRightPanel] = useState(false);
  const user = useSelector((state: RootState) => state.auth.user as User);
  const dispatch: AppDispatch = useDispatch();
  const [videoRef, stream] = useMediaStream();
  const [isLeftPanelOpen, setIsLeftPanelOpen] = useState(true);
  const [shouldRenderLeftPanel, setShouldRenderLeftPanel] = useState(false);
  const { session } = useSelector((state: RootState) => state.live.settings);
  const session_id = useSelector((state: RootState) => state.live.settings.roomId);
  const [briefDocDataCs, setBriefDocDataCs] = useState<{ case_url: string }[]>([])
  const [briefDocData, setBriefDocData] = useState<{ role_name?: string; attachment_url?: string, activityData: any, attachment_type?: string }>({ role_name: '', attachment_url: '', activityData: {}, attachment_type: 'url' });
  const [showPresentModalPermission, setShowPresentModalPermission] = useState(false);
  const socketList: socketContextType[] = useContext(SocketContext);
  let userInfoHandler = useRef<UserInfoMapperSocketHandler>(null);
  const [briefIcon, setBriefIcon] = useState(false);
  const [documentUrl, setDocumentUrl] = useState('');
  const [mediaUrl, setMediaUrl] = useState('');
  const [consoleDetailData, setConsoleDetailData] = useState<any>();
  const consumers = useSelector((state: RootState) => state.live.settings.consumers);
  const audioRefs = useRef<{ [key: string]: HTMLAudioElement | null }>({});
  const trainerJoinedtable = useSelector((state: RootState) => state.live.settings.trainerJoinedtable);
  const [screenShare, setScreenShare] = useState<any>(Object.values(settings.consumers || {}).find((consumer: any) => consumer.appData?.share === true) as Consumer | undefined || {});
  const [screen, setScreen] = useState<string>(screenTypes.STREAMING);
  const [sessionMode, setSessionMode] = useState(
    sessionModeType.NETWORKING_MODE
  );
  const [showDialog, setShowDialog] = useState(false);
  const dropoutState = useSelector((state: any) => state.countReducer?.response);
  const datachannel = urlParser.query.datachannel !== 'false';
  const produce = urlParser.query.produce !== 'false';
  const [showPresentationButton, setShowPresentationButton] = useState(false);
  const [seatingStyle, setSeatingStyle] = useState("");
  const batchData = useSelector((state: RootState) => state.live.settings.batch);
  const roomState = useSelector((state: RootState) => state.live.settings.roomState);
  const count = useSelector((state: RootState) => state.countReducer);
  const [responseShow, setResponseShow] = useState();
  const [audioConsumers, setAudioConsumers] = useState([]);
  const [pollData, setPollData] = useState<any>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  var _userId = batchData?.participants?.filter((x: any) => x?.email?.toLowerCase() == user?.email?.toLowerCase());
  let countReducer = useSelector((state: any) => state.countReducer);
  const [messageCount, setMessageCount] = useState(0);
  const mode: any = useSelector((state: RootState) => state.live.settings.mode);
  const [sidebar, setSidebar] = useState({ SessionSidebarWidth: 0, ParticipantSidebarWidth: 0, sidebarOpen: false });
  const [notchPath, setNotchPath] = useState(`
    M 0,0 L 0.348,0 Q 0.356,0.00032 0.365,0.0112 Q 0.376,0.0401 0.394,0.0401 L 0.639,0.0401 Q 0.654,0.0401 0.668,0.0112 Q 0.677,0.00048 0.686,0 L 1,0 L 1,1 L 0.989,1 L 0.979,1 L 0.713,1 Q 0.681,0.9968 0.668,0.98 Q 0.654,0.959 0.639,0.959 L 0.498,0.959 L 0.387,0.959 Q 0.372,0.959 0.364,0.979 Q 0.355,0.9968 0.337,1 L 0,1 Z
  `);
  const liveSessionService = new LiveSessionService();
  const { participantPanelWidth, sessionPanelWidth, participantPanelOpen, sessionPlanPanelOpen } = useSelector((state: RootState) => state.countReducer);
  const [tableData, setTableData] = useState<any>([]);
  const [myTableData, setMyTableData] = useState<any>([]);
  const [tblDataSnap, setTblDataSnap] = useState<any>({});
  const [activityData, setActivityData] = useState<any>({});
  const [csActivityData, setCSActivityData] = useState<any>({});
  const [viewCaseTitle, setViewCaseTitle] = useState(false)
  const [instructorPresentorData, setInstructorPresentorData] = useState({
    individual: {},
    group: {},

    isIndividualPresentor: false,
    isIndividualPresentorIsMe: false,

    isGroupPresentor: false,
    isPresentingGroupIsOurs: false,
    isPresentingGroupIsOthers: false,
    isGroupPresentorIsMe: false,
  });
  const [alter, setAlter] = useState(false);
  const [isAnnouncementEnabled, setIsAnnouncementEnabled] = useState(false);
  const [activeEmojis, setActiveEmojis] = useState<any[]>([]);
  const [showUnraisePopup, setShowUnraisePopup] = useState(false);
  const [popupQuery, setPopupQuery] = useState<string>('');
  const [isProcessingDropout, setIsProcessingDropout] = useState(true); // New state for tracking dropout processing
  const peersArray = useSelector((state: any) => state.live.settings?.peersNew || {});
  const peerList = Object.keys(peersArray).filter(k => k !== 'trainer@vtt');
  const participantCount = peerList.length + 1;
  let primarycolour: any;
  let secoundarycolour: any;
  let theme: any;
  const isFOrceMute = useSelector((state: RootState) => state?.live?.settings?.sessionSettingData?.forceMute);

  if (_userId?.length > 0) {
    var _pId = _userId[0].id;// this is participant ID.
  }

  useEffect(() => {
    addAttendance()
  }, [roomState])

  const addAttendance = async () => {
    if (roomState === 'connected') {
      try {
        const response = await axiosInstance.post("/trainee/attendance/add", {
          email: user?.email,
          status: 'join',
          session_map_id: Number(sessionId) || sessionId,
          participant_id: user?.id,
        });
      }
      catch (error) {
        console.log(error);
      }
    }
  }

  useEffect(() => {
    setAudioConsumers(Object.values(consumers)?.filter(
      (c) => (c.track?.kind || c.kind) === "audio" && c.track?.readyState === "live"
    ));
    console.log('audioConsumers', audioConsumers);
  }, [consumers])

  useEffect(() => {
    dispatch(fetchLiveSessionActivityData({ roomID: session_id }));
  }, [session_id])

  useEffect(() => {
    if (!userInfoHandler.current) {
      userInfoHandler.current = validateAndCreateSocketIfExist(
        session_id,
        handleOnMessage,
        socketList
      );
    }
    return () => {
      dispatch(setMicState({ mic: 'on' }));
    }
  }, []);

  useEffect(() => {
    // push dummy history entry so back triggers our popstate handler
    window.history.pushState({ liveSessionActive: true }, "", window.location.href);

    const handlePopState = (event: PopStateEvent) => {
      // prevent immediate navigation
      event.preventDefault();
      setShowDialog(true);
      // push dummy entry again so user stays until confirming
      window.history.pushState({ liveSessionActive: true }, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    // Handle refresh/tab close
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "You are leaving the live session.";
      return e.returnValue;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleConfirmLeave = async () => {
    dispatch(resetLiveStreamSettings());
    await roomClientRef.current?.close();
    setShowDialog(false);
    navigate(`/configuration?sessionId=${sessionId}&programId=${programId}`);
  };

  const handleCancelLeave = () => {
    setShowDialog(false);
  };


  useEffect(() => {
    setConsoleDetailData(consoleDetails);
  }, [consoleDetails]);

  useEffect(() => {
    if (consumers) {
      const screenShareConsumer = Object.values(settings.consumers || {}).find(
        (consumer: any) => consumer.appData?.share === true
      ) as Consumer | undefined;
      setScreenShare(screenShareConsumer);
    }
  }, [consumers]);

  useEffect(() => {
    const updateNotch = () => {
      const screenWidth = window.innerWidth;
      let scaleHeightTop = 1; // Scale for top notch height
      let scaleHeightBottom = 1; // Scale for bottom notch height
      let scaleWidthTop = 1; // Scale for top notch width
      let scaleWidthBottom = 1; // Scale for bottom notch width

      // Adjust scales based on screen width
      if (screenWidth < 640) { // Mobile
        scaleHeightTop = 0.8; // 40% larger top notch height
        scaleHeightBottom = 0; // 40% larger bottom notch height
        scaleWidthTop = 2.1; // 30% wider top notch
        scaleWidthBottom = 2.4; // 30% wider bottom notch
      } else if (screenWidth < 769) { // big Mobiles
        scaleHeightTop = 1.2; // 20% larger top notch height
        scaleHeightBottom = 1.2; // 20% larger bottom notch height
        scaleWidthTop = 1.6; // 15% wider top notch
        scaleWidthBottom = 1.6; // 15% wider bottom notch
      } else if (screenWidth < 1025) { // Tablet
        scaleHeightTop = 1.2; // 20% larger top notch height
        scaleHeightBottom = 1.2; // 20% larger bottom notch height
        scaleWidthTop = 1.15; // 15% wider top notch
        scaleWidthBottom = 1.15; // 15% wider bottom notch
      } else if (screenWidth < 1279) {
        scaleHeightTop = 0.8; // Original size
        scaleHeightBottom = 1; // Original size
        scaleWidthTop = 0.8; // Original width
        scaleWidthBottom = 0.8; // Original width
      } else if (screenWidth < 1536) { // Desktop
        scaleHeightTop = 0.8; // Original size
        scaleHeightBottom = 0.8; // Original size
        scaleWidthTop = 1; // Original width
        scaleWidthBottom = 1; // Original width
      }
      // Original coordinates
      const originalPath = [
        { type: 'M', x: 0, y: 0 },
        { type: 'L', x: 0.348, y: 0 },
        { type: 'Q', x1: 0.356, y1: 0.00032, x2: 0.365, y2: 0.0112 },
        { type: 'Q', x1: 0.376, y1: 0.0401, x2: 0.394, y2: 0.0401 },
        { type: 'L', x: 0.639, y: 0.0401 },
        { type: 'Q', x1: 0.654, y1: 0.0401, x2: 0.668, y2: 0.0112 },
        { type: 'Q', x1: 0.677, y1: 0.00048, x2: 0.686, y2: 0 },
        { type: 'L', x: 1, y: 0 },
        { type: 'L', x: 1, y: 1 },
        { type: 'L', x: 0.989, y: 1 },
        { type: 'L', x: 0.979, y: 1 },
        { type: 'L', x: 0.713, y: 1 },
        { type: 'Q', x1: 0.681, y1: 0.9968, x2: 0.668, y2: 0.98 },
        { type: 'Q', x1: 0.654, y1: 0.959, x2: 0.639, y2: 0.959 },
        { type: 'L', x: 0.498, y: 0.959 },
        { type: 'L', x: 0.387, y: 0.959 },
        { type: 'Q', x1: 0.372, y1: 0.959, x2: 0.364, y2: 0.979 },
        { type: 'Q', x1: 0.355, y1: 0.9968, x2: 0.337, y2: 1 },
        { type: 'L', x: 0, y: 1 },
        { type: 'Z' }
      ];

      // Center points for notches (for width scaling)
      const topNotchCenterX = (0.348 + 0.686) / 2; // ≈ 0.517
      const bottomNotchCenterX = (0.337 + 0.713) / 2; // ≈ 0.525

      // Scale coordinates
      const scaledPath = originalPath.map(point => {
        if (point.type === 'Z') return point;
        const scaledPoint = { ...point };

        // Scale y-coordinates for height
        if ('y' in point) {
          scaledPoint.y = point.y <= 0.5 ? point.y * scaleHeightTop : (1 - (1 - point.y) * scaleHeightBottom);
        }
        if ('y1' in point) {
          scaledPoint.y1 = point.y1 <= 0.5 ? point.y1 * scaleHeightTop : (1 - (1 - point.y1) * scaleHeightBottom);
        }
        if ('y2' in point) {
          scaledPoint.y2 = point.y2 <= 0.5 ? point.y2 * scaleHeightTop : (1 - (1 - point.y2) * scaleHeightBottom);
        }

        // Scale x-coordinates for width
        if ('x' in point) {
          const centerX = point.y <= 0.5 ? topNotchCenterX : bottomNotchCenterX;
          const scaleWidth = point.y <= 0.5 ? scaleWidthTop : scaleWidthBottom;
          scaledPoint.x = centerX + (point.x - centerX) * scaleWidth;
        }
        if ('x1' in point) {
          const centerX = point.y1 <= 0.5 ? topNotchCenterX : bottomNotchCenterX;
          const scaleWidth = point.y1 <= 0.5 ? scaleWidthTop : scaleWidthBottom;
          scaledPoint.x1 = centerX + (point.x1 - centerX) * scaleWidth;
        }
        if ('x2' in point) {
          const centerX = point.y2 <= 0.5 ? topNotchCenterX : bottomNotchCenterX;
          const scaleWidth = point.y2 <= 0.5 ? scaleWidthTop : scaleWidthBottom;
          scaledPoint.x2 = centerX + (point.x2 - centerX) * scaleWidth;
        }

        return scaledPoint;
      });

      // Construct the new path string
      const newNotchPath = scaledPath.map(point => {
        if (point.type === 'M') return `M ${point.x.toFixed(6)},${point.y.toFixed(6)}`;
        if (point.type === 'L') return `L ${point.x.toFixed(6)},${point.y.toFixed(6)}`;
        if (point.type === 'Q') return `Q ${point.x1.toFixed(6)},${point.y1.toFixed(6)} ${point.x2.toFixed(6)},${point.y2.toFixed(6)}`;
        if (point.type === 'Z') return 'Z';
      }).join(' ');

      setNotchPath(newNotchPath);
    };

    updateNotch();
    window.addEventListener('resize', updateNotch);
    dispatch(updateSidePanelData({ sessionPlanPanelOpen: shouldRenderLeftPanel ? shouldRenderLeftPanel : false, participantPanelOpen: shouldRenderRightPanel ? shouldRenderRightPanel : false }))
    return () => window.removeEventListener('resize', updateNotch);
  }, []);
  useEffect(() => {
    setSidebar({
      ParticipantSidebarWidth: participantPanelWidth,
      SessionSidebarWidth: sessionPanelWidth,
      sidebarOpen: true,
    });
  }, [participantPanelWidth, sessionPanelWidth,]);

  useEffect(() => {
    var totalCount = 0;
    for (var i = 0; i < countReducer.private.length; i++) {
      totalCount += parseInt(countReducer.private[i].count);
    }
    setMessageCount(totalCount + countReducer.commonCount + countReducer.newBadgeCount)
  }, [countReducer])

  useEffect(() => {
    if (
      batchData?.sittingStyle &&
      batchData?.sittingStyle[0] &&
      batchData?.sittingStyle[0]?.seating_type
    ) {
      setSeatingStyle(batchData?.sittingStyle[0]?.seating_type);
    }
  }, [batchData?.sittingStyle]);

  useEffect(() => {
    if (batchData && batchData?.sittingStyle?.length > 0) {
      if (batchData?.sittingStyle && batchData?.sittingStyle[0] && batchData?.sittingStyle[0]?.table && !batchData?.sittingStyle[0]?.assign_manually) {
        setParticipants(JSON.parse(batchData?.sittingStyle[0]?.table))
      }
      else {
        setTableData(JSON.parse(batchData?.sittingStyle[0]?.table))
        setTblDataSnap(JSON.parse(batchData?.sittingStyle[0]?.table))
      }
    }
  }, [batchData])

  useEffect(() => {
    if (tableData && tableData?.length > 0) {
      dispatch(
        updateLiveStreamSettings({
          allGroup: tableData
        })
      );
      tableData?.forEach((e1: any) => {
        e1?.seats?.forEach((e2: any) => {
          if (e2?.email == user?.email) {
            dispatch(
              updateLiveStreamSettings({
                myGroup: e1
              })
            )
            setMyTableData(e1)
            getGroupLeader(e1)
          }
        });
      });
      return
    }
  }, [tableData]);
  const producers = useSelector((state: RootState) => state.live.settings.producers);

  const audioProducer: any = useMemo(() =>
    Object.values(producers).find((p: any) => p.kind === 'audio'),
    [producers]
  );

  const videoProducer: any = useMemo(() =>
    Object.values(producers).find((p: any) => p.kind === 'video'),
    [producers]
  );

  useEffect(() => {
    dispatch(updateLiveStreamSettings({ leftPanel: "participantPanel" }));
  }, [dispatch]);

  useEffect(() => {
    if (settings.theme) {
      primarycolour = settings.theme.theme.primaryColor;
      secoundarycolour = settings.theme.theme.secondaryColor;
      theme = settings.theme.logo;
    }
  }, [settings.theme]);

  useEffect(() => {
    if (roomClientRef.current) return;
    roomClientRef.current = new RoomClient({
      roomId: settings.roomId || "default-room",
      peerId: user?.email || "default-peer",
      displayName: user?.name || "User",
      dispatch,
      store,
      userId: user.id,
      datachannel,
      produce,
      bgImage: '',
      consume: true
    });

    roomClientRef.current.join(settings.audio, settings.video);

    // return () => {
    //   if (roomClientRef.current) {
    //     roomClientRef.current.close();
    //     roomClientRef.current = null;
    //   }
    // };
  }, [settings.roomId]);

  // useEffect(() => {
  //   if (roomClientRef.current && settings.audio !== undefined) {
  //     console.log("settings.audio bye", settings.audio);
  //     if (audioProducer && audioProducer.paused) {
  //       roomClientRef.current.unmuteMic();
  //       return;
  //     }
  //     if (settings.audio) {
  //       if (!audioProducer) {  // Only enable if no producer 
  //         console.log("enableMic bye");
  //         roomClientRef.current.enableMic();
  //       }
  //     } else {
  //       if (audioProducer && !audioProducer.paused) {  // Only mute if producer exists and not paused
  //         roomClientRef.current.muteMic();
  //       }
  //     }
  //   }
  // }, [settings.audio]);

  // useEffect(() => {
  //   if (roomClientRef.current && settings.video !== undefined) {
  //     settings.video
  //       ? roomClientRef.current.enableWebcam()
  //       : roomClientRef.current.disableWebcam();
  //   }
  // }, [settings.video]);

  // Handle panel animation mount/unmount
  useEffect(() => {
    if (isLeftPanelOpen) {
      setShouldRenderLeftPanel(true);
    } else {
      const timeout = setTimeout(() => setShouldRenderLeftPanel(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [isLeftPanelOpen]);

  useEffect(() => {
    if (roomState !== 'connected') return;

    if (sessionMode === sessionModeType.NETWORKING_MODE) {
      if (session.id) {
        console.log('Calling validateAndCheckResumeStatus with session_id:', session.id);
        validateAndCheckResumeStatus(session.id);
      } else {
        console.log('sessionData.session_id is undefined');
      }
    } else {
      console.log('sessionMode is not NETWORKING_MODE');
    }
  }, [roomState]);

  useEffect(() => {
    const panelState: SidePanelState = {
      participantPanelOpen: false,
      participantPanelWidth: 300,
      sessionPlanPanelOpen: false,
      sessionPanelWidth: 300,
    };

    if (isLeftPanelOpen) {
      panelState.participantPanelOpen = true;
      panelState.participantPanelWidth = 300;
    }

    if (showPanel) {
      panelState.sessionPlanPanelOpen = true;
      panelState.sessionPanelWidth = 300;
    }

    dispatch(updateSidePanelData(panelState));
  }, [isLeftPanelOpen, showPanel]);

  useEffect(() => {
    if (showPanel) {
      setShouldRenderRightPanel(true);
    } else {
      const timeout = setTimeout(() => setShouldRenderRightPanel(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [showPanel]);

  const checkIfActivityHappening = () => {
    return (
      screen === screenTypes.ROLEPLAY ||
      screen === screenTypes.CASESTUDY ||
      screen === screenTypes.GROUPDISCUSSION ||
      screen === screenTypes.POLL
    );
  };

  const processSocketEvents = async (dropoutState) => {
    // Default error handling for invalid input
    if (!dropoutState) {
      console.error('processSocketEvents: dropoutState is undefined or null');
      return { success: false, error: 'dropoutState is undefined or null' };
    }
    if (typeof dropoutState !== 'object') {
      console.error('processSocketEvents: dropoutState is not a valid object');
      return { success: false, error: 'dropoutState is not a valid object' };
    }
    try {
      // Validate required properties with defaults
      const socketEvents = Array.isArray(dropoutState.socketEvents) ? dropoutState.socketEvents : [];
      const launchActivities = Array.isArray(dropoutState.launchActivities) ? dropoutState.launchActivities : [];
      console.log(`Processing socket events: ${socketEvents.length} events, ${launchActivities.length} activities`);
      // // Dispatch response if available
      // if (dropoutState.message) {
      //   try {
      //     dispatch(addResponse(dropoutState));
      //   } catch (dispatchError) {
      //     console.warn('Failed to dispatch response:', dispatchError);
      //     // Continue processing even if dispatch fails
      //   }
      // }
      // 1. Get ongoing activities (where actualEndTime is null)
      const ongoingActivities = launchActivities.filter(activity => {
        try {
          return activity && activity.actualEndTime === null;
        } catch (error) {
          console.warn('Error checking activity end time:', error);
          return false;
        }
      });
      if (ongoingActivities.length === 0) {
        console.log("No ongoing activities found");
        return { success: true, message: "No ongoing activities found" };
      }
      // 2. Find the LATEST ongoing activity (most recently launched/relaunched)
      const latestActivity = ongoingActivities.reduce((latest, current) => {
        try {
          const currentTime = current.actualStartTime ? new Date(current.actualStartTime).getTime() : 0;
          const latestTime = latest.actualStartTime ? new Date(latest.actualStartTime).getTime() : 0;
          return currentTime > latestTime ? current : latest;
        } catch (error) {
          console.warn('Error comparing activity timestamps:', error);
          return latest;
        }
      });
      if (!latestActivity || !latestActivity.id) {
        console.log("No valid latest activity found");
        return { success: true, message: "No valid latest activity found" };
      }
      console.log(`Found latest activity: ID ${latestActivity.id}, started at: ${latestActivity.actualStartTime}`);
      // 3. Filter socket events for ONLY the latest activity
      const latestActivitySocketEvents = socketEvents.filter(event => {
        try {
          return event &&
            event.sessionActivityExecutionLog_Id &&
            event.sessionActivityExecutionLog_Id === latestActivity.id;
        } catch (error) {
          console.warn('Error filtering socket event:', error);
          return false;
        }
      });
      if (latestActivitySocketEvents.length === 0) {
        console.log(`No socket events found for latest activity (ID: ${latestActivity.id})`);
        return { success: true, message: `No socket events found for latest activity (ID: ${latestActivity.id})` };
      }
      // 4. Sort events by timestamp in ascending order with error handling
      const sortedEvents = latestActivitySocketEvents.sort((a, b) => {
        try {
          const timestampA = a.timestamp ? parseInt(a.timestamp) : 0;
          const timestampB = b.timestamp ? parseInt(b.timestamp) : 0;
          if (isNaN(timestampA) || isNaN(timestampB)) {
            console.warn('Invalid timestamp found during sorting, using fallback order');
            return 0;
          }
          return timestampA - timestampB;
        } catch (error) {
          console.warn('Error sorting events:', error);
          return 0;
        }
      });
      console.log(`Processing ${sortedEvents.length} socket events for latest activity (ID: ${latestActivity.id}) in chronological order`);
      // 5. Process events in order with individual error handling
      const processingResults = {
        total: sortedEvents.length,
        successful: 0,
        failed: 0,
        errors: [],
        latestActivityId: latestActivity.id
      };
      for (let i = 0; i < sortedEvents.length; i++) {
        const event = sortedEvents[i];
        // Validate event before processing
        if (!event || !event.message) {
          console.warn(`Skipping invalid event at index ${i}`);
          processingResults.failed++;
          processingResults.errors.push({
            index: i,
            error: 'Invalid event structure - missing message'
          });
          continue;
        }
        console.log(`--- Starting event #${i} (Activity: ${event.sessionActivityExecutionLog_Id}, Type: ${event.eventType}, Timestamp: ${event.timestamp}) ---`);
        try {
          // Validate handleOnMessage function exists
          if (typeof handleOnMessage !== 'function') {
            throw new Error('handleOnMessage is not a function');
          }
          await handleOnMessage(event.message);
          processingResults.successful++;
          // Wait for 1 second for UI updates, with timeout protection
          await new Promise<void>((resolve) => {
            const timeoutId = setTimeout(() => {
              resolve();
            }, 1100);
            // Clear timeout if resolved normally
            setTimeout(() => {
              clearTimeout(timeoutId);
              resolve();
            }, 1000);
          });
          console.log(`Finished event #${i}`);
        } catch (error) {
          console.error(`Error in event #${i}:`, error);
          processingResults.failed++;
          processingResults.errors.push({
            index: i,
            eventId: event.id,
            activityId: event.sessionActivityExecutionLog_Id,
            eventType: event.eventType,
            error: error.message || 'Unknown error'
          });
          // Continue processing other events even if one fails
          console.log('Continuing with next event...');
        }
      }
      // 6. Final result summary
      const result = {
        success: processingResults.failed === 0,
        message: `Processed ${processingResults.successful}/${processingResults.total} events for latest activity (ID: ${latestActivity.id})`,
        latestActivityId: latestActivity.id,
        details: processingResults
      };
      if (processingResults.failed > 0) {
        console.warn(`Completed with ${processingResults.failed} failures:`, result);
      } else {
        console.log(`All socket events for latest activity (ID: ${latestActivity.id}) processed successfully`);
      }
      return result;
    } catch (error) {
      // Catch-all for any unexpected errors
      console.error("Unexpected error in processSocketEvents:", error);
      const errorResult = {
        success: false,
        error: 'Unexpected processing error',
        details: error.message || 'Unknown error occurred'
      };
      return errorResult;
    }
  };

  useEffect(() => {
    if (dropoutState && roomState === 'connected') {
      setIsProcessingDropout(true); // Set loading state to true when starting to process
      processSocketEvents(dropoutState).then(() => {
        setIsProcessingDropout(false); // Set loading state to false when processing is complete
      }).catch((error) => {
        console.error('Error processing socket events:', error);
        setIsProcessingDropout(false); // Ensure loading state is cleared even on error
      });
    } else {
      setIsProcessingDropout(false); // No dropoutState or not connected, no need to process
    }
  }, [dropoutState, roomState]);

  const validateAndCheckResumeStatus = async (session_id) => {
    if (!session_id) {
      console.error('validateAndCheckResumeStatus: session_id is undefined or invalid');
      return;
    }

    try {
      const res: any = await liveSessionService.fetchDropout(session_id);
      console.log(res, "cccccccccccccccccccccccccccccccccc");
      dispatch(addResponse(res));

      if (res?.socketEvents && Array.isArray(res.socketEvents)) {
        for (let i = 0; i < res.socketEvents.length; i++) {
          const event = res.socketEvents[i];
          console.log(`--- Starting event #${i} ---`);

          try {
            await handleOnMessage(event.message);
            // Wait for 1 second so the UI can update and user can see the change
            await new Promise(resolve => setTimeout(resolve, 1000));
            console.log(`✓ Finished event #${i}`);
          } catch (e) {
            console.error(`✗ Error in event #${i}:`, e);
          }
        }
      } else {
        console.log("No socketEvents found in the response or socketEvents is not an array.");
      }
    } catch (error) {
      console.error("Error in validateAndCheckResumeStatus:", error);
    }
  };

  const setParticipants = (td: any[]) => {
    let from = 0;
    let to = batchData?.sittingStyle[0]?.nos_of_participant_on_table;
    td.map((v: any, i: number) => {
      let p = batchData?.participants?.slice(from, to)
      from = to;
      to = to + batchData?.sittingStyle[0]?.nos_of_participant_on_table;
      td[i].seats = p
    })
    setTableData([...td])
    setTblDataSnap([...td])
  }

  const renderScreen = () => {
    switch (screen) {
      case screenTypes.ROLEPLAY:
        return (
          <RolePlay
            roomClient={roomClientRef.current}
            showPresentButton={showPresentationButton}
            showPresentModal={() => {
              setShowPresentModalPermission(true)
            }}
            activityData={activityData}
            messageCount={messageCount}
            consoleDetailData={consoleDetailData}
            onBrief={(bd) => {
              setBriefDocData(bd)
              setDocumentUrl(bd)
              // setShowNextPreviousModal(5)
            }}
          />
        )
      // case screenTypes.SCREEN_SHARE:
      //   return ();
      //   case screenTypes.ROLEPLAY:
      //   return ();
      //     case screenTypes.CASESTUDY:
      //   return ();
      //   case screenTypes.HANDLE_AUDIO_VIDEO_DOC:
      //   return ();
      //   case screenTypes.CUSTOMACTIVITY:
      //   return ();
      case screenTypes.CASESTUDY:
        return <CaseStudyScreen
          // showPresentButton={showPresentationButton}
          // showPresentModal={(value: boolean) => {
          //   setShowPresentModalPermission(true)
          // }}
          showViewCaseTitle={(value: boolean) => {
            setViewCaseTitle(value)
          }}
          sessionId={session_id}
          tableData={(item: any) => setBriefDocDataCs(item)}
          activityData={csActivityData}
          roomClient={roomClientRef.current}
          onBrief={(bd) => {
            setBriefDocData(bd)
            setBriefDocDataCs(bd)
          }}
          documentUrl={documentUrl}
        />
      case screenTypes.GROUPDISCUSSION:
        return <GroupDiscussion
          sessionId={session_id}
          messageCount={messageCount}
          instructorPresentorData={instructorPresentorData}
          alter={alter}
          roomClient={roomClientRef.current}
          onBrief={(bd) => {
            setBriefDocData(bd)
            setBriefDocDataCs(bd)
          }}
        />;
      case screenTypes.POLL:
        return (
          <PollActivity roomClient={roomClientRef.current} session_id={session_id} resSettings={responseShow} />
        );
      case 'media':
        return (
          <VideoScreen handleCloseEvent={() => { setScreen(undefined); setSessionMode(undefined) }} url={mediaUrl} />
        );
      case 'document':
        return (
          <MyDocumentViewer handleCloseEvent={() => { setScreen(undefined); setSessionMode(undefined) }} url={mediaUrl} />
        );
      default:
        return renderSessionMode();
    }
  };

  const renderSessionMode = () => {
    switch (sessionMode) {
      case sessionModeType.ACTIVITY_MODE:
        return renderSeating();
      case sessionModeType.INSTRUCTOR_MODE:
        return <InstructorModeMainScreen roomClient={roomClientRef.current} />;
      default:
        return renderSeating();
    }
  };

  const renderSeating = () => {
    switch (seatingStyle) {
      case "Cluster":
        return (
          <ClusterTableSittingAlignment roomClient={roomClientRef.current} />
        );
      // case 'U-Shaped':
      //   return <UShaped />;
      // case 'Classroom':
      //   return <Classroom />;
      default:
        return (
          <ClusterTableSittingAlignment roomClient={roomClientRef.current} />
        );
    }
  };

  const getGroupLeader = (v: any) => {
    v?.seats?.forEach((e: any) => {
      if (e?.group_leader) {
        dispatch(
          updateLiveStreamSettings({
            groupLeader: e
          })
        )
      }
    });
  };

  const isBlankOrNull = (value: string) => {
    return !value || value?.length === 0 || value === 'null' || value === 'undefined';
  }

  const parseToJson: any = (data: string) => {
    if (typeof data === typeof '') {
      try {
        return parseToJson(JSON.parse(data));
      } catch (err) {
        console.log('Error parsing JSON', data)
        return {}
      }
    } else {
      return data;
    }
  }

  const getActivityData = async (data: any) => {
    const activity_id = data?.launched_activity_id;
    let request = {
      id: activity_id,
    };
    if (!isBlankOrNull(activity_id)) {
      // if it's pre-planned or launch from session plan, activity_id will be available. activity_id here is the ID of the sessionSegment or quick_setup_activities table. if it's launch now, this will not be available. Rely on the data coming through the socket in this case.
      console.log('data?.activityData?.type', data?.activityData?.type, request);
      if (data?.activityData?.type == sessionPlanActivityType.QUICK_LAUNCH) {
        // if it's pre-planned and
        try {
          let res: any = await activityService.getQuickActivityData(request);
          if (res?.code == 200) {
            setActivityData({ ...activityData, activity_data: parseToJson(res?.data?.activity_data) })
            console.log("res 434 :", res)
          } else {
            console.warn("error 436-->", res)
          }
        } catch (error) {
          console.log("error 439-->", error)
        }
      } else if (data?.activityData?.type == sessionPlanActivityType.PRE_PLANNED) {
        console.log(activity_id, 'Id')
        try {
          let res: any = await activityService.getSegmentActivity(request);
          if (res?.status) {
            setActivityData({ ...activityData, ...res?.data?.activity_data })
            console.log("res :", res)
          } else {
            console.log("error 449-->", res)
            setActivityData({ ...activityData, ...res?.data?.traineeData })
          }
        } catch (error) {
          console.log("error 453-->", error)
        }
      }
    } else {
      console.log('setting activity data directly')
      // this activity may not be saved at the backend. rely on the data from the socket immediately.
      if (data?.activityData) {
        setActivityData({ ...activityData, ...parseToJson(data?.activityData) })
      }
    }
  };

  const handleOnMessage = async (_data: any) => {
    console.log("🚀 ~ ClassRoom ~ handleOnMessage ~ _data:", _data);
    const data = JSON.parse(_data);
    console.log("🚀 ~ ClassRoom ~ handleOnMessage ~ _data:", data);

    if (
      (data?.type === socketMessageType.SESSION_MODE &&
        (data?.status === "LAUNCH" || data?.status === "RELAUNCH") &&
        (data?.activityId == '3' || data?.activityId == '2')) ||
      (data?.type === socketMessageType.SESSION_MODE &&
        data?.value === sessionModeType.INSTRUCTOR_MODE) ||
      data?.type === "role_play" ||
      data?.type === "case_study" ||
      data?.type === "group_discussion" ||
      data?.type === "poll"
    ) {
      dispatch(fetchLiveSessionActivityData({ roomID: session_id }));
    }


    if (data?.type == socketMessageType.SESSION_MODE) {
      setSessionMode(data?.value);
      if (data?.value === sessionModeType.INSTRUCTOR_MODE) {
      }
      dispatch(
        updateLiveStreamSettings({
          mode: data.value,
        })
      );
      if (data?.value == sessionModeType.INSTRUCTOR_MODE) {
        setScreen(screenTypes?.STREAMING)//default props type straming
      } else if (data?.value == sessionModeType.ACTIVITY_MODE) {
        setSeatingStyle('Cluster');
      }
      // else {
      //   setSessionMode(sessionModeType.NETWORKING_MODE)
      //   setScreen(screenTypes?.STREAMING);//default props type straming
      //   setSeatingStyle('Cluster')
      //   renderSeating();
      // }
      return
    }
    if (data?.type == 'chat_message') {
      console.log('data123', data, _pId);
      // TODO: Is this trainee ID or participant ID?
      if (_userId?.length > 0) {
        if (data.message?.message_by_id == _pId) {
          // this is me only who have sent the message
          return;
        }
      }
      // dispatch({
      //   type: 'IS_TIMER_STARTED',
      //   payload: {
      //     isTimerStarted: true,
      //   }
      // });

      if (data.sub_type === "class" || data.sub_type === "common") {
        dispatch(addCommonCount());
      } else if (data.sub_type === 'individual' || data.sub_type === 'private') {
        if (data.message.message_by == 'Trainer') {
          // message is from trainer
        }
        if (data?.chat_box_id?.includes(_pId?.toString())) {
          console.log('adding to private chat')
          // message have came for me.
          dispatch(addPrivateCount({
            count: 1,  // Set the initial count to 0
            id: data?.chat_box_id || data?.room_id
          }));
        }
      }
    }

    if (data?.type === 'broadcast_poll') {
      // for poll we had to implement these use cases because when poll is triggered poll screen is not mounted yet on trainee side.
      // This is anti-pattern but has to be done.
      if (data?.sub_type === 'dot_show_question_screen_score') {
        setResponseShow(data)
      }
      else if (data?.sub_type == "show_question_screen_score") {
        setResponseShow(data)
      }
      else if (data?.sub_type == "show_initial_screen") {
        setResponseShow(data)
      }
    }
    if (data?.type === 'case_study' && data?.sub_type === 'setting_caseUrl') {
      setBriefIcon(true);
      const activityData = JSON.parse(data?.activityData?.activity_data || '{}');
      setCSActivityData(activityData);
      const { brief } = activityData;
      if (activityData?.shareCaseEach === 1) {
        // Case where all groups have the same case URL in the brief
        const sharedCaseUrl = activityData.case_url;
        if (sharedCaseUrl) {
          setDocumentUrl(sharedCaseUrl);
        }
      } else if (activityData?.shareCaseEach === 2) {
        // Case where each group has a different case URL in the brief
        const caseGroups = activityData.case;
        caseGroups.forEach((group: any) => {
          group.seats.forEach((participant: any) => {
            if (user.email === participant.participant_email) {
              // Find the matching brief entry based on table_name
              const matchedBrief = brief.find(
                (briefItem: any) => briefItem.table_name === group.table_name
              );
              if (matchedBrief) {
                setDocumentUrl(matchedBrief.case_url);
              }
            }
          });
        });
      }
    }
    if (data?.type == socketMessageType.GROUP_DISCUSSION) {
      getActivityData(data);
      setScreen(screenTypes.GROUPDISCUSSION)
    }
    if (data?.type == socketMessageType.CASE_STUDY) {
      getActivityData(data);
      setScreen(screenTypes.CASESTUDY)
    }
    if (data?.type === 'Ask_to_present') {
      if (data?.sub_type === 'for_trainee') {
        // setIsTraineeRepresentingGroupNow(false);
        // setPresentingGroupName('');
        setInstructorPresentorData({
          ...instructorPresentorData,
          individual: data?.trainee
        })
        if (data?.trainee?.participant_email == user?.email) {
          setInstructorPresentorData({
            ...instructorPresentorData,

            individual: data?.trainee,
            isIndividualPresentor: true,
            isIndividualPresentorIsMe: true,

            isGroupPresentor: false,
            isPresentingGroupIsOurs: false,
            isPresentingGroupIsOthers: false,
            isGroupPresentorIsMe: false,
          })
        } else {
          setInstructorPresentorData({
            ...instructorPresentorData,
            individual: data?.trainee,
            isIndividualPresentor: true,
            isIndividualPresentorIsMe: false,

            isGroupPresentor: false,
            isPresentingGroupIsOurs: false,
            isPresentingGroupIsOthers: false,
            isGroupPresentorIsMe: false,
          })
        }
      }

      if (data?.sub_type === 'for_group') {
        setInstructorPresentorData({
          ...instructorPresentorData,
          group: data?.tableData,
          isIndividualPresentor: false,
          isIndividualPresentorIsMe: false,

          isGroupPresentor: true,
          isPresentingGroupIsOurs: false,
          isPresentingGroupIsOthers: false,
          isGroupPresentorIsMe: false,
        })
      }


      if (data?.sub_type === 'trainee_accepted_group_presentation_request') {
        if (data?.trainee?.participant_email == user?.email) {
          setInstructorPresentorData({
            ...instructorPresentorData,
            individual: data?.trainee,

            isIndividualPresentor: false,
            isIndividualPresentorIsMe: false,

            isGroupPresentor: true,
            isPresentingGroupIsOurs: true,
            isPresentingGroupIsOthers: false,
            isGroupPresentorIsMe: true,
          })
          // setAlter(!alter)
        } else {
          setInstructorPresentorData({
            ...instructorPresentorData,
            individual: data?.trainee,

            isIndividualPresentor: false,
            isIndividualPresentorIsMe: false,

            isGroupPresentor: true,
            isPresentingGroupIsOurs: false,
            isPresentingGroupIsOthers: true,
            isGroupPresentorIsMe: false,
          })
          setAlter(!alter)
        }
      }


      if (data?.sub_type === 'Ask_to_End_Presentation') {
        setInstructorPresentorData({
          ...instructorPresentorData,

          isIndividualPresentor: false,
          isIndividualPresentorIsMe: false,

          isGroupPresentor: false,
          isPresentingGroupIsOurs: false,
          isPresentingGroupIsOthers: false,
          isGroupPresentorIsMe: false,
        })
        // setAlter(!alter)
        // setIsPresentationEnded(true)
        // return
      }
    }
    if (data?.type == socketMessageType.broadcast_poll) {
      if (data.sub_type !== "completely_close_the_poll") {
        setScreen(screenTypes.POLL)
      }
    };
    if (data?.type === 'session_meta_info') {
      if (data.sub_type === 'enable_group_intereaction') {
        dispatch(
          updateSessionSettings({
            enableGroupIntereaction: true,
          })
        );
      } else if (data.sub_type === 'disable_group_intereaction') {
        dispatch(
          updateSessionSettings({
            enableGroupIntereaction: false,
          })
        );
      } else if (data.sub_type === 'mute_all_participants') {
        dispatch(
          updateSessionSettings({
            forceMute: true,
            micState: 'forceMuted'
          })
        );
      } else if (data.sub_type === 'allow_all_to_speak') {
        dispatch(
          updateSessionSettings({
            forceMute: false,
            micState: 'enabled'
          })
        );
      } else if (data.sub_type === 'system_mute_on') {
        // Note: systemMute is not defined in LiveStreamSettingsState interface
        // If you intend to add systemMute, update the interface first
        dispatch(
          updateSessionSettings({
            systemMute: true, // Uncomment and add to interface if needed
            micState: 'systemMuted'
          })
        );
      }
    }
    if (data.type === 'networking_mode') {
      if (data?.sub_type === 'trainer_toggle_joined_group') {
        dispatch(updateLiveStreamSettings({
          trainerJoinedtable: {
            isTrainerPresent: data?.isTrainerPresent,
            groupName: `Group ${Number(data?.updated_table_index) + 1}`,
            TrainerJoinTableData: data.newGroups
          }
        }))
      }
    }
    if (data?.type == socketMessageType.SPLIT_ROOM) {
      if (data?.sub_type === undefined) {
        dispatch(
          updateLiveStreamSettings({
            allGroup: [...data?.newGroups?.table]
          })
        )
        setTableData([...data?.newGroups?.table])
        setTblDataSnap([...data?.newGroups?.table])
        // set my table data
        data?.newGroups?.table?.forEach((e1: any) => {
          e1?.seats?.forEach((e2: any) => {
            if (e2?.participant_email == user?.email) {
              dispatch(
                updateLiveStreamSettings({
                  myGroup: e1
                })
              )
              setMyTableData(e1)
              getGroupLeader(e1)
            }
          });
        });
        return
      }
    }
    if ((data?.type == socketMessageType.ROLE_PLAY && !data?.sub_type) || (data?.type == socketMessageType.MANUAL_ROLE_PLAY && !data?.sub_type)) {
      getActivityData(data);
      setScreen(screenTypes.ROLEPLAY)
      return
    } else if (data?.type == socketMessageType.MANUAL_ROLE_PLAY && !data?.sub_type) {
      getActivityData(data);
      setScreen(screenTypes.ROLEPLAY)
      return
    }

    if (data?.type == 'segment_launched') {
      if (data.sub_type === 'play_video') {
        if (data?.media_type == 'Video') {
          setMediaUrl(data.media);
          setScreen('media')
          return
        }
      } else if (data.sub_type === 'close_video') {
        setMediaUrl(null)
        setScreen('classroom')//default screen
      }

      else if (data?.media_type == 'Document') {
        setMediaUrl(data.media);
        setScreen('document')
        return
      }
    }
    if (data?.type === 'announcement') {
      if (data?.sub_type == 'announcement_on') {
        console.log('announcement on');
        setIsAnnouncementEnabled(true);
      }
      if (data?.sub_type == 'announcement_close') {
        console.log('announcement close');
        setIsAnnouncementEnabled(false);
      }
    }
    if (data?.type === 'show_emojies') {
      const emojiWithId = {
        ...data,
        id: `${Date.now()}-${Math.random()}`,
        randomOffset: Math.random() * 200 - 100
      };

      setActiveEmojis(prev => [...prev, emojiWithId]);
    }
  }

  const handleEmojiClose = (emojiId: string) => {
    setActiveEmojis(prev => prev.filter(emoji => emoji.id !== emojiId));
  };

  const handleScroll = (direction: "up" | "down") => {
    if (contentRef.current) {
      const scrollAmount = 600; // Adjust scroll amount as needed
      contentRef.current.scrollBy({
        top: direction === "up" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };


  const changingBackground = useSelector(
    (state: RootState) => state.live?.settings?.backgroundEffect ?? false
  );

  const sessionLiveFlag = useSelector(
    (state: RootState) => state.live?.settings?.sessionLiveFlag,
  );

  const handleApplyBackGround = (imageUrl: any) => {
    // @ts-ignore
    roomClientRef?.current?.changeBgImage(imageUrl);
  }

  const removeBackground = () => {
    // @ts-ignore
    // roomClientRef?.changeBgImage(null);
    dispatch(
      updateLiveStreamSettings({ backgroundEffect: false })
    );
  }


  const applyBackgroundEffect = (imageUrl: string) => {
    const userEmail = user?.email;
    if (!userEmail) return;

    if (sessionLiveFlag) {
      handleApplyBackGround({ [userEmail]: imageUrl });

      dispatch(
        updateLiveStreamSettings({
          bgImage: {
            ...bgImage,
            [userEmail]: imageUrl,
          },
        })
      );
    } else {
      dispatch(
        updateLiveStreamSettings({
          pendingBg: {
            ...pendingBg,
            [userEmail]: imageUrl,
          },
        })
      );
    }
  };

  useEffect(() => {
    const userEmail = user?.email;
    if (sessionLiveFlag && userEmail && pendingBg?.[userEmail]) {
      const timer = setTimeout(() => {
        handleApplyBackGround({ [userEmail]: pendingBg[userEmail] });

        dispatch(
          updateLiveStreamSettings({
            pendingBg: {
              ...pendingBg,
              [userEmail]: undefined,
            },
          })
        );
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [sessionLiveFlag, pendingBg, user?.email]);



  const showAutoUnraisePopup = (queryType: string) => {
    setPopupQuery(queryType);
    setShowUnraisePopup(true);

    setTimeout(() => {
      setShowUnraisePopup(false);
    }, 3000);
  };

  const handleAutoUnraise = (queryType: string) => {
    dispatch(unraiseQuery(queryType));
    sendLowerHand(queryType);
    showAutoUnraisePopup(queryType);
  };

  const sendLowerHand = async (queryType: string) => {
    const formattedTime = new Date().toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    userInfoHandler.current = validateAndCreateSocketIfExist(
      settings.roomId,
      () => { },
      socketList
    );

    const message = {
      type: socketMessageType?.RAISE_HAND,
      user_reaction_data: {
        reaction_type: "lower_hand",
        reacted_by_email: user?.email,
        reacted_by_name: user?.name,
        reacted_by_type: "trainee",
        query_message: queryType === "raise_hand" ? "Raise a Hand" : queryType,
        time: formattedTime,
      },
      room_id: settings.roomId,
    };

    userInfoHandler.current.sendMessage(JSON.stringify(message));

    await axiosInstance.post("/session/create_session_raised_hand", {
      session_map_id: Number(settings.roomId),
      content: JSON.stringify({
        reaction_type: "lower_hand",
        reacted_by_email: user?.email,
        reacted_by_name: user?.name,
        reacted_by_type: "trainee",
        query_message: queryType === "raise_hand" ? null : queryType,
        time: formattedTime,
      }),
      trainee_id: user?.id,
      type: "lower_hand",
    });
  };

  useEffect(() => {
    if (!activeQueries || typeof activeQueries !== 'object') {
      console.warn('activeQueries is empty or invalid:', activeQueries);
      return;
    }

    console.log('Active queries changed:', activeQueries);

    Object.entries(activeQueries).forEach(([queryType, queryData]) => {
      const raisedAt = queryData?.raisedAt;
      if (!raisedAt) {
        console.warn(`Query "${queryType}" missing raisedAt value`, queryData);
        return;
      }

      const timeElapsed = Date.now() - raisedAt;
      const timeRemaining = 20000 - timeElapsed;

      console.log(
        `Query "${queryType}": raised ${Math.round(timeElapsed / 1000)}s ago, ${Math.round(timeRemaining / 1000)}s remaining`
      );
    });
  }, [activeQueries]);

  return (
    roomState === "connected" ? (
      <>
        {/* SVG Notch Clip */}
        <svg width="0" height="0">
          <defs>
            <clipPath id="notch-clip" clipPathUnits="objectBoundingBox">
              <path d={notchPath} />
            </clipPath>
          </defs>
        </svg>

        {/* ROOT WRAPPER */}
        <div
          className="fixed inset-0 flex flex-col z-0 px-3"
          style={{
            background: primarycolour
              ? primarycolour
              : "linear-gradient(112.61deg, #363e70 -8.91%, #ec6ae5 115.4%)",
          }}
        >

          {/* Toggle Buttons */}
          {/* LEFT PANEL TOGGLE */}
          <div
            className={`fixed z-50 top-1/2 -translate-y-1/2 transition-all duration-500 
      ${isLeftPanelOpen ? "left-[270px]" : "laptop:left-[10px] tablet:left-[10px] left-[15px]"} 
      flex items-center gap-1 tablet:hidden mobile:hidden`}
          >
            <button
              onClick={() => setIsLeftPanelOpen((prev) => !prev)}
              className="w-7 h-7 rounded-full bg-app-blue flex items-center justify-center shadow-md hover:bg-blue-700 transition"
            >
              <GoArrowSwitch
                size={16}
                className={`transform transition-transform ${isLeftPanelOpen ? "rotate-180" : "rotate-0"}`}
              />
            </button>
          </div>

          {/* RIGHT PANEL TOGGLE */}
          <div
            className={`fixed z-50 top-1/2 -translate-y-1/2 transition-all duration-500 
      ${showPanel ? "right-[270px]" : "laptop:right-[10px] tablet:right-[10px] right-[15px]"} 
      flex items-center gap-1 tablet:hidden mobile:hidden`}
          >
            <button
              onClick={() => setShowPanel((prev) => !prev)}
              className="w-7 h-7 rounded-full bg-app-blue flex items-center justify-center shadow-md hover:bg-blue-700 transition"
            >
              <GoArrowSwitch size={16} />
            </button>
          </div>

          {/* HEADER */}
          <div className="flex-none relative p-2">
            <div className="flex mobile:flex-col mobile:justify-center items-center justify-between h-full">
              <div className="w-1/3 flex mobile:w-full mobile:justify-center items-center text-white font-semibold">
                {user?.name && (
                  <span className="text-sm laptop:text-base text-yellow-400">
                    Welcome, <span className="text-yellow-400">{user.name}</span>
                  </span>
                )}
              </div>
              <div className="flex flex-col items-center justify-center">
                <span className="text-base sm:text-lg md:text-xl font-normal text-yellow-500">
                  {session?.session_name}
                </span>
                <span className="text-xs laptop:text-md tablet:text-base font-medium text-white">
                  Duration: {session?.startTime} - {session?.endTime}
                </span>
              </div>
              <div className="w-1/3 flex justify-end mobile:hidden">
                <ModeHeading />
              </div>
            </div>
            <div className="-bottom-20 absolute right-2 z-[9999999999] laptop:hidden desktop:hidden tablet:hidden largescreen:hidden xxl:hidden">
              <LogoutControl roomClient={roomClientRef.current} />
            </div>
          </div>

          {/* MAIN CONTENT */}
          <div className="flex-1 relative overflow-hidden bg-[#1D1731] text-white rounded-[20px] notch" style={{ clipPath: "url(#notch-clip)" }}>
            {/* Draggable card */}
            <TraineeDraggableCard roomClient={roomClientRef.current} />

            {/* LEFT PANEL */}
            {shouldRenderLeftPanel && (
              <div
                className={`absolute top-0 bottom-0 left-0 w-[300px] bg-[#1c1b2d] z-30
          rounded-tr-3xl rounded-br-3xl rounded-tl-3xl rounded-bl-xl
          shadow-[2px_2px_6px_rgba(255,255,255,0.3)]
          overflow-hidden transition-opacity duration-500 ease-in-out mobile:hidden
          ${isLeftPanelOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
              >
                <LeftPanel />
              </div>
            )}

            {!isLeftPanelOpen && (
              <div
                className={`absolute top-1/2 -translate-y-1/2 w-[3%] h-[80%] bg-[#393C41] z-30
          rounded-tr-3xl rounded-br-3xl rounded-tl-xl rounded-bl-3xl
          shadow-[2px_2px_6px_rgba(255,255,255,0.3)]
          flex flex-col items-center justify-start pt-20 text-white
          transition-opacity duration-500 ease-in-out mobile:hidden`}
              >
                <span className="tracking-wide rotate-90 px-2 whitespace-nowrap">
                  Participants
                  <span className="ml-2 text-app-yellow">{participantCount}</span>/
                  <span>{batch?.participants.length}</span>
                </span>
              </div>
            )}

            {/* RIGHT PANEL */}
            {shouldRenderRightPanel && (
              <div
                className={`absolute top-0 bottom-0 right-0 w-[300px] bg-[#3B4350] z-30
          rounded-tl-3xl rounded-bl-3xl rounded-tr-xl rounded-br-xl
          shadow-[2px_2px_6px_rgba(0,0,0,0.25),_-2px_-2px_4px_rgba(255,255,255,0.25)]
          overflow-hidden transition-opacity duration-500 ease-in-out mobile:hidden
          ${showPanel ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
              >
                <SessionPlanPanel />
              </div>
            )}

            {!showPanel && (
              <div
                className={`absolute top-1/2 -translate-y-1/2 right-0 w-[3%] h-[80%] bg-[#393C41] z-30
          rounded-tl-3xl rounded-bl-3xl rounded-tr-3xl rounded-br-xl
          shadow-[2px_2px_6px_rgba(0,0,0,0.25),_-2px_-2px_4px_rgba(255,255,255,0.25)]
          flex flex-col items-center justify-start pt-20 text-white
          transition-opacity duration-500 ease-in-out mobile:hidden`}
              >
                <span className="tracking-wide -rotate-90 px-2 whitespace-nowrap">
                  Session Plan
                </span>
              </div>
            )}
            {/* MAIN SCREEN AREA */}
            {isProcessingDropout ? (
              <div className="w-full h-full flex items-center justify-center bg-black/50">
                <div className="flex flex-col items-center gap-4">
                  <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span className="text-white text-xl font-medium">Loading...</span>
                </div>
              </div>
            ) : (
              (isProcessingDropout === false || isProcessingDropout === null || isProcessingDropout === undefined) && (
                <div
                  ref={contentRef}
                  className="w-full h-[80vh] largescreen:h-[80vh] laptop:h-[95%] desktop:h-[78vh] mobile:h-[91%] flex justify-center box-border"
                  style={
                    isMobileOrTablet
                      ? {}
                      : {
                        paddingLeft: `${sidebar.ParticipantSidebarWidth}px`,
                        paddingRight: `${sidebar.SessionSidebarWidth}px`,
                      }
                  }
                >
                  {isAnnouncementEnabled && (
                    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
                      <div className="bg-[#24272C] rounded-2xl shadow-2xl max-w-md w-[90%] p-6 text-center relative animate-fadeIn">
                        <img
                          src="./img/campaign.png"
                          alt="Announcement Icon"
                        />
                        <h2 className="text-2xl font-semibold text-[#E9BE50] mb-3">Announcement</h2>
                        <p className="text-[#FFFFFF] mb-6">
                          This is an important announcement for all participants. Please pay attention to the trainer's instructions.
                        </p>
                      </div>
                    </div>
                  )}

                  {screenShare &&
                    (sessionMode == sessionModeType?.INSTRUCTOR_MODE ||
                      sessionMode == sessionModeType?.ACTIVITY_MODE) &&
                    !checkIfActivityHappening() ? (
                    <div className="w-full h-full">
                      {isFOrceMute && (
                        <div className="absolute top-5 shadow-md bg-black bg-opacity-30 p-2 mobile:top-12 laptop:top-12 mobile:left-[4px] tablet:right-[240px] laptop:right-[35px] desktop:right-[340px] largescreen:right-[380px] xxl:right-[450px] z-[99999]">
                          <img src="./img/forceMute.png" alt="" className="h-14 mobile:h-10" />
                        </div>
                      )}
                      <ScreenSharingComponent
                        consumer={screenShare}
                        isLocal={screenShare.appData?.peerId === user?.email}
                      />
                    </div>
                  ) : (
                    <div className="w-full h-full flex flex-col">
                      {isFOrceMute && (
                        <div className="absolute top-5 shadow-md bg-black bg-opacity-30 p-2 mobile:top-12 laptop:top-12 mobile:left-[4px] tablet:right-[240px] laptop:right-[35px] desktop:right-[340px] largescreen:right-[380px] xxl:right-[450px] z-[99999]">
                          <img src="./img/forceMute.png" alt="" className="h-14 mobile:h-10" />
                        </div>
                      )}
                      {sessionMode !== sessionModeType.INSTRUCTOR_MODE && <div className="flex justify-center items-center flex-shrink desktop:mt-5 laptop:mt-5 largescreen:mt-8  mt-8">
                        <Trainer
                          videoHeight={150}
                          videoWidth={250}
                          name={trainer?.fullname}
                          trainerTableName="On Table 1"
                        />
                      </div>}
                      <div className="flex-1 h-full overflow-y-auto w-full scrollbar-hide">
                        {renderScreen()}
                      </div>
                    </div>
                  )}
                </div>
              )
            )}
          </div>

          {/* FOOTER SECTION */}
          <div className="flex-none relative mobile:h-[25px] h-[50px]">
            {/* Logo */}
            <div className="absolute left-0 top-0 m-2 mobile:ml-8">
              <img src={Icon.logo} alt="Viliyo Logo" className="w-[60px] mobile:hidden" />
            </div>

            {/* Console */}
            <div className="absolute bottom-0 left-1/2 mobile:-ml-1 ml-4 -translate-x-1/2 mb-2 z-30">
              <ConsoleControlPanel roomClient={roomClientRef.current} />
            </div>
          </div>

          {/* Logout */}
          <div className="absolute z-40 mobile:hidden bottom-4 right-8">
            <LogoutControl roomClient={roomClientRef.current} />
          </div>
        </div>
        {changingBackground ? (
          <ChangeBackGround
            closePopup={removeBackground}
            applyBackgroundEffect={(imageUrl: any) => applyBackgroundEffect(imageUrl)}
          />
        ) : null}
        {audioConsumers
          ?.filter(
            (c: any) =>
              (c.track?.kind || c.kind) === "audio" &&
              c.track?.readyState === "live" &&
              c.locallyPaused !== true
          )
          .map((c: any) => (
            <AudioPlayer consumer={c} key={c.id} />
          ))}

        {activeEmojis.map((emoji, index) => (
          <EmojiePopup
            key={emoji.id} // Unique key for each emoji
            handleCloseEvent={() => handleEmojiClose(emoji.id)}
            currentEmojieDetails={emoji}
            randomOffset={emoji.randomOffset}
          />
        ))}
        {
          showUnraisePopup && (
            <div className="fixed top-4 right-4 z-50 bg-green-600 text-white px-4 py-3 rounded-lg shadow-lg animate-fade-in">
              <div className="flex items-center gap-3">
                <FaHandPaper className="text-white" />
                <div>
                  <p className="font-semibold">Query Auto-closed</p>
                  <p className="text-sm opacity-90">
                    {popupQuery === "raise_hand" ? "Raise Hand" : popupQuery} was automatically closed after 20 seconds
                  </p>
                </div>
              </div>
            </div>
          )
        }
        {/* <QueryPopup /> */}
        {briefDocData && briefDocData?.attachment_url ? (
          <BriefPopup
            activityData={briefDocData?.activityData}
            role_name={briefDocData?.role_name}
            attachment_url={briefDocData?.attachment_url}
            attachment_type={briefDocData?.attachment_type} // Add this line
            closePopup={() => setBriefDocData(null)}
          />
        ) : null}

        <Dialog.Root open={showDialog} onOpenChange={setShowDialog}>
          <Dialog.Content
            className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg max-w-md w-full"
          >
            <Dialog.Title className="text-lg font-semibold text-gray-900">
              Leave Live Session?
            </Dialog.Title>
            <Text as="p" className="mt-2 text-gray-600">
              You are about to leave the live session. Are you sure?
            </Text>
            <div className="mt-6 flex justify-end space-x-3">
              <Button
                variant="soft"
                color="gray"
                onClick={handleCancelLeave}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
              >
                Cancel
              </Button>
              <Button
                variant="solid"
                color="red"
                onClick={handleConfirmLeave}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Leave
              </Button>
            </div>
          </Dialog.Content>
        </Dialog.Root>
      </>
    ) : (
      <div className="w-screen h-screen bg-black flex items-center justify-center">
        <span className="text-white text-xl sm:text-2xl font-medium animate-pulse">
          Connecting...
        </span>
      </div>
    )
  );
};

export default ClassRoom;

const BriefPopup = (props: { activityData: any, role_name?: string, attachment_url?: string, attachment_type?: string, closePopup: () => void }) => {
  const [openUrl, setOpenUrl] = useState("");

  const computeUrlToSet = useCallback(() => {
    // If it's text type, return empty string to handle separately
    if (props.attachment_type === 'text') {
      return '';
    }

    const { activityData, attachment_url } = props;
    if (!activityData) return '';

    if (activityData?.types_of_role_play !== undefined) {
      if (activityData?.types_of_role_play === 2) {
        const roleWithUrl = activityData?.roles?.find((r: any) => r.attachment_url);
        return roleWithUrl?.attachment_url || activityData.role_brief_url || '';
      }
      if (activityData?.types_of_role_play === 1 || activityData?.types_of_role_play === 4) {
        const role = activityData.roles?.find((r: any) => r.role_name === props.role_name);
        return role?.attachment_url || '';
      }
      if (activityData?.types_of_role_play !== 5) {
        return activityData.role_brief_url || attachment_url || '';
      }
    }

    return attachment_url || '';
  }, [props.activityData, props.attachment_url, props.role_name, props.attachment_type]);

  useEffect(() => {
    setOpenUrl(computeUrlToSet());
  }, [computeUrlToSet]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 mobile:p-2">
      <div className="bg-white rounded-lg shadow-xl w-[90%] tablet:w-[80%] laptop:w-[70%] desktop:w-[65%] largescreen:w-[60%] h-[85vh] tablet:h-[90vh] flex flex-col">
        <div className="flex flex-col h-full">
          <div className="w-full h-full flex flex-col">

            {/* Header */}
            <div
              className="flex justify-between items-center p-4 border-b rounded-t-lg flex-shrink-0"
              style={{ backgroundColor: '#e8bd4f', color: '#222126' }}
            >
              <span className="text-lg font-semibold">
                {props.role_name} Brief
              </span>

              <div className="flex items-center gap-2">
                {/* Open in new tab - only show for URLs */}
                {openUrl && (
                  <a
                    href={openUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 hover:bg-black hover:bg-opacity-10 rounded transition-colors duration-200 flex items-center gap-1"
                    title="Open in new tab"
                  >
                    <FaExternalLinkAlt className="w-4 h-4" /> Open in new tab
                  </a>
                )}

                {/* Close */}
                <button
                  onClick={() => props.closePopup()}
                  className="p-2 hover:bg-black hover:bg-opacity-10 rounded transition-colors duration-200"
                  title="Close"
                >
                  <FaTimes className="w-5 h-5" />
                </button>
              </div>
            </div>

            {/* Body */}
            <div className="flex-1 p-4 overflow-hidden min-h-0">
              {props.activityData?.types_of_role_play === 5 ? (
                <MediaPlayer url={props?.activityData?.role_brief_url || null} />
              ) : props.attachment_type === 'text' ? (
                // Handle text content directly
                <div className="h-full overflow-auto bg-gray-50 p-4">
                  <pre className="whitespace-pre-wrap font-sans text-sm">
                    {props.attachment_url}
                  </pre>
                </div>
              ) : openUrl ? (
                <DocumentRender url={openUrl} />
              ) : (
                <div className="flex items-center justify-center h-full text-gray-500">
                  No document available
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const getFileType = (fileName = '') => {
  if (!fileName) return '';
  const parts = fileName.split('.');
  return parts.length > 1 ? parts.pop()?.toLowerCase() : '';
};

const DocumentRender = (props) => {
  const { url } = props;
  const fileType = getFileType(url);

  // For PDF files
  if (fileType === 'pdf') {
    return (
      <div className="w-full h-full">
        <iframe
          key={url}
          src={url}
          width="100%"
          height="100%"
          frameBorder="0"
          title="PDF Document Viewer"
          className="w-full h-full"
        />
      </div>
    );
  }

  // Office documents
  const officeFileTypes = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
  if (officeFileTypes.includes(fileType)) {
    return (
      <div className="w-full h-full">
        <iframe
          key={url}
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
          width="100%"
          height="100%"
          frameBorder="0"
          title="Office Document Viewer"
          className="w-full h-full"
        />
      </div>
    );
  }

  // For image files
  const imageFileTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
  if (imageFileTypes.includes(fileType)) {
    return (
      <div className="w-full h-full flex items-center justify-center overflow-auto">
        <img
          src={url}
          alt="Document"
          className="max-w-full max-h-full object-contain"
          onError={(e: any) => {
            e.target.style.display = 'none';
            e.target.parentElement.innerHTML = '<div class="text-red-600">Failed to load image</div>';
          }}
        />
      </div>
    );
  }

  // For text files
  if (fileType === 'txt') {
    return (
      <TextFileViewer url={url} />
    );
  }

  // For other file types - direct download
  return (
    <div className="flex flex-col items-center justify-center h-full text-center p-4">
      <div className="text-gray-600 mb-4">
        Preview not available for {fileType || 'this'} file type
      </div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="px-4 py-2 bg-app-blue text-white rounded hover:bg-opacity-90 transition-colors"
      >
        Download File
      </a>
    </div>
  );
};

// Text file viewer component
const TextFileViewer = ({ url }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTextFile = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to load text file');
        const text = await response.text();
        setContent(text);
      } catch (error) {
        console.error('Error loading text file:', error);
        setError('Failed to load text file');
      } finally {
        setLoading(false);
      }
    };

    fetchTextFile();
  }, [url]);

  if (loading) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-red-600">{error}</div>
      </div>
    );
  }

  return (
    <div className="h-full overflow-auto bg-gray-50">
      <pre className="whitespace-pre-wrap p-4 font-sans text-sm">
        {content}
      </pre>
    </div>
  );
};

const MediaPlayer = (props) => {
  const { url } = props;

  if (!url) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-gray-100 rounded">
        <div className="text-gray-600">No media URL provided</div>
      </div>
    );
  }

  return (
    <div className="w-full h-full flex items-center justify-center bg-black rounded">
      <ReactPlayer
        controls={true}
        url={url}
        width="100%"
        height="100%"
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload'
            }
          }
        }}
      />
    </div>
  );
};